module.exports = "/images/vessel-13.jpg";